import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
export default function FinalCTA() {
  const navigate = useNavigate();
  return (
    <section id="final-cta" data-testid="final-cta-section" className="py-20 md:py-28 px-6 bg-blue-600 relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full blur-[100px] opacity-30 pointer-events-none" />
      <div className="max-w-3xl mx-auto relative z-10 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <span className="text-xs tracking-widest uppercase font-semibold text-blue-200 mb-4 block">Ready to Travel?</span>
          <h2 className="heading-font text-3xl md:text-5xl font-bold text-white mb-5">Start Your Visa Process Today</h2>
          <p className="text-blue-100 max-w-xl mx-auto mb-8">Join thousands of satisfied travelers. Transparent pricing, real-time tracking, 98% approval rate.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <motion.button whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} data-testid="cta-apply-btn" onClick={() => navigate("/register")}
              className="w-full sm:w-auto text-blue-600 font-semibold bg-white px-8 py-3.5 rounded-xl hover:bg-blue-50 transition-all flex items-center justify-center gap-2 shadow-lg">
              Start Application <ArrowRight className="w-4 h-4" />
            </motion.button>
            <motion.button whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }} data-testid="cta-quote-btn" onClick={() => navigate("/visa-calendar")}
              className="w-full sm:w-auto text-white font-medium px-8 py-3.5 rounded-xl border border-white/30 hover:bg-white/10 transition-all">
              Visa Cost Calendar
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
